/** Quantos chamados por página, e quantas páginas no máximo. */
export const POR_PAGINA = 200;
export const TETO_DE_PAGINAS = 20;

/**
 * A lista de "abertos hoje", INTEIRA, vinda do servidor.
 *
 * ## Por que esta lista não é refinada no navegador como as outras
 *
 * Quatro dos cinco cards dos indicadores recortam dentro da lista de ativos,
 * que a tela de chamados já tem toda em memória -- refinar ali dá o número
 * certo. "Abertos hoje" não: ele conta o que foi CRIADO hoje, resolvido ou
 * não (decisão do dono do produto em 02/10), e os finalizados chegam de 100
 * em 100 conforme a rolagem. Refinando no navegador, o número da lista
 * dependia de quanto o operador havia rolado -- a origem do relato "o card
 * diz 30 e a lista mostra 18".
 *
 * ## Por que `created_today=1` e não as bordas do dia
 *
 * Assim "hoje" sai de `Ticket::scopeCriadosHoje()` na api, a MESMA expressão
 * que o número do card usa. Se o navegador calculasse início e fim do dia,
 * "hoje" passaria a depender do fuso do cliente enquanto o card depende do
 * fuso do servidor (`America/Sao_Paulo`) -- e número e lista voltariam a
 * divergir, agora só para quem estivesse em outro fuso.
 *
 * ## Por que em laço, e não por rolagem
 *
 * O número do card tem de bater com a lista COMPLETA. Carregar só a primeira
 * página reproduziria o defeito que isto conserta, com outro valor.
 *
 * O teto de páginas existe para um dia anormal não virar laço infinito. Ele
 * nunca deve ser alcançado -- 4.000 chamados criados num único dia --, e por
 * isso a função devolve `total` separado de `linhas`: quem chama compara os
 * dois e avisa na tela se cortou, em vez de mostrar menos do que o card
 * prometeu em silêncio.
 *
 * @param {(url: string, config: object) => Promise} get a função de GET (o `http.get`)
 * @returns {Promise<{linhas: Array, total: number, cortou: boolean}>}
 */
export const buscarCriadosHoje = async (get) => {
    const linhas = [];
    let pagina = 1;
    let ultima = 1;
    let total = null;

    do {
        // eslint-disable-next-line no-await-in-loop
        const res = await get('/ticket/paginated', {
            params: { per_page: POR_PAGINA, page: pagina, created_today: 1 },
        });

        const dados = res?.data?.data;
        linhas.push(...(Array.isArray(dados) ? dados : []));
        ultima = res?.data?.last_page || 1;
        // `total` do servidor e nao `linhas.length`: e ele que o card mostra,
        // e e a comparacao entre os dois que denuncia um corte.
        total = res?.data?.total ?? linhas.length;
        pagina += 1;
    } while (pagina <= ultima && pagina <= TETO_DE_PAGINAS);

    return { linhas, total, cortou: linhas.length < total };
};
